"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styles_1 = __importDefault(require("./styles"));
var PivotTable = function (_a) {
    var rows = _a.rows, children = _a.children, testId = _a.testId, _b = _a.addPaddingBottom, addPaddingBottom = _b === void 0 ? false : _b;
    var classes = (0, styles_1.default)({ addPaddingBottom: addPaddingBottom });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.container, "data-testid": testId }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.column }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.blankCell }, { children: "\u00A0" })), rows.map(function (_a) {
                        var title = _a.title, items = _a.items;
                        return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ role: "rowheader", className: classes.sectionHeader }, { children: title })), items.map(function (_a) {
                                    var key = _a.key, label = _a.label;
                                    return ((0, jsx_runtime_1.jsx)("div", __assign({ "data-testid": "".concat(title, " - ").concat(label), className: classes.sectionCell }, { children: label }), key));
                                })] }, title));
                    })] })), children] })));
};
exports.PivotTable = PivotTable;
